import axios from 'axios';
import { authActions } from '../context/AuthContext';
// config
import { HOST_API } from '../config';
import { bumpSession } from './authSessionManager';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers : { 
    // 'Content-Type': 'multipart/form-data',
  }
});

axiosInstance.interceptors.request.use((config) => {
  bumpSession();
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    // token invalid / expired
    if (status === 401) {
      try {
        authActions.logout?.(); // panggil logout global
      } catch (e) {
        // ignore
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
